import {RouteConfig} from "vue-router";
import MasterLayout from "@/components/layouts/MasterLayoutComponent.vue";

const routes: Array<RouteConfig> = [
  {
    path: "/admin/cms_pages",
    name: "CMSPageList",
    component: () => import("../views/CMSPage/CMSPageList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_pages/add",
    name: "CMSPageAdd",
    component: () => import("../views/CMSPage/CMSPageForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_pages/:id/edit",
    name: "CMSPageEdit",
    component: () => import("../views/CMSPage/CMSPageForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_pages/:id/show",
    name: "CMSPageShow",
    component: () => import("../views/CMSPage/CMSPageShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_templates",
    name: "CMSTemplateList",
    component: () => import("../views/CMSTemplate/CMSTemplateList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_templates/add",
    name: "CMSTemplateAdd",
    component: () => import("../views/CMSTemplate/CMSTemplateForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_templates/:id/edit",
    name: "CMSTemplateEdit",
    component: () => import("../views/CMSTemplate/CMSTemplateForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_templates/:id/show",
    name: "CMSTemplateShow",
    component: () => import("../views/CMSTemplate/CMSTemplateShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_global_settings",
    name: "CMSGlobalSettingList",
    component: () => import("../views/CMSGlobalSetting/CMSGlobalSettingList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_global_settings/add",
    name: "CMSGlobalSettingAdd",
    component: () => import("../views/CMSGlobalSetting/CMSGlobalSettingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_global_settings/:id/edit",
    name: "CMSGlobalSettingEdit",
    component: () => import("../views/CMSGlobalSetting/CMSGlobalSettingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_global_settings/:id/show",
    name: "CMSGlobalSettingShow",
    component: () => import("../views/CMSGlobalSetting/CMSGlobalSettingShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/media_manager",
    name: "CMSMediaManager",
    component: () => import("../views/MediaManager/MediaManager.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_custom_fields",
    name: "CMSCustomFieldList",
    component: () => import("../views/CMSCustomField/CMSCustomFieldList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_custom_fields/add",
    name: "CMSCustomFieldAdd",
    component: () => import("../views/CMSCustomField/CMSCustomFieldForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_custom_fields/:id/edit",
    name: "CMSCustomFieldEdit",
    component: () => import("../views/CMSCustomField/CMSCustomFieldForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_custom_fields/:id/show",
    name: "CMSCustomFieldShow",
    component: () => import("../views/CMSCustomField/CMSCustomFieldShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_menu_groups",
    name: "CmsMenuGroupList",
    component: () => import("../views/CMSMenuGroup/CmsMenuGroupList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_menu_groups/add",
    name: "CmsMenuGroupAdd",
    component: () => import("../views/CMSMenuGroup/CmsMenuGroupForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_menu_groups/:id/edit",
    name: "CmsMenuGroupEdit",
    component: () => import("../views/CMSMenuGroup/CmsMenuGroupForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_menu_groups/:id/show",
    name: "CmsMenuGroupShow",
    component: () => import("../views/CMSMenuGroup/CmsMenuGroupShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_menu_settings",
    name: "CmsMenuSettingList",
    component: () => import("../views/CMSMenuSetting/CmsMenuSettingList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_menu_settings/add",
    name: "CmsMenuSettingAdd",
    component: () => import("../views/CMSMenuSetting/CmsMenuSettingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_menu_settings/:id/edit",
    name: "CmsMenuSettingEdit",
    component: () => import("../views/CMSMenuSetting/CmsMenuSettingForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_menu_settings/:id/render",
    name: "CmsMenuGroupRender",
    component: () => import("../views/CMSMenuGroupShow/CmsMenuGroup.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_menu_settings/:id/show",
    name: "CmsMenuSettingShow",
    component: () => import("../views/CMSMenuSetting/CmsMenuSettingShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_blog_categories",
    name: "CMSBlogCategoryList",
    component: () => import("../views/CMSBlogCategory/CMSBlogCategoryList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },

  {
    path: "/admin/cms_blog_categories/add",
    name: "CMSBlogCategoryAdd",
    component: () => import("../views/CMSBlogCategory/CMSBlogCategoryForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_blog_categories/:id/edit",
    name: "CMSBlogCategoryEdit",
    component: () => import("../views/CMSBlogCategory/CMSBlogCategoryForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_blog_categories/:id/show",
    name: "CMSBlogCategoryShow",
    component: () => import("../views/CMSBlogCategory/CMSBlogCategoryShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_blog_subcategories",
    name: "CMSBlogSubCategoryList",
    component: () => import("../views/CMSBlogSubCategory/CMSBlogSubCategoryList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_blog_subcategories/add",
    name: "CMSBlogSubCategoryAdd",
    component: () => import("../views/CMSBlogSubCategory/CMSBlogSubCategoryForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_blog_subcategories/:id/edit",
    name: "CMSBlogSubCategoryEdit",
    component: () => import("../views/CMSBlogSubCategory/CMSBlogSubCategoryForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_blog_subcategories/:id/show",
    name: "CMSBlogSubCategoryShow",
    component: () => import("../views/CMSBlogSubCategory/CMSBlogSubCategoryShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_blogs",
    name: "CMSBlogList",
    component: () => import("../views/CMSBlog/CMSBlogList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_blogs/add",
    name: "CMSBlogAdd",
    component: () => import("../views/CMSBlog/CMSBlogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_blogs/:id/edit",
    name: "CMSBlogEdit",
    component: () => import("../views/CMSBlog/CMSBlogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_blogs/:id/show",
    name: "CMSBlogShow",
    component: () => import("../views/CMSBlog/CMSBlogShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_blog_tags",
    name: "CMSBlogTagList",
    component: () => import("../views/CMSBlogTag/CMSBlogTagList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_blog_tags/add",
    name: "CMSBlogTagAdd",
    component: () => import("../views/CMSBlogTag/CMSBlogTagForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_blog_tags/:id/edit",
    name: "CMSBlogTagEdit",
    component: () => import("../views/CMSBlogTag/CMSBlogTagForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_blog_tags/:id/show",
    name: "CMSBlogTagShow",
    component: () => import("../views/CMSBlogTag/CMSBlogTagShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_email_forms",
    name: "CMSEmailFormList",
    component: () => import("../views/CMSEmailForm/CMSEmailFormList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_email_forms/add",
    name: "CMSEmailFormAdd",
    component: () => import("../views/CMSEmailForm/CMSEmailFormForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_email_forms/:id/edit",
    name: "CMSEmailFormEdit",
    component: () => import("../views/CMSEmailForm/CMSEmailFormForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_email_forms/:id/show",
    name: "CMSEmailFormShow",
    component: () => import("../views/CMSEmailForm/CMSEmailFormShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_email_form_logs",
    name: "CMSEmailFormLogList",
    component: () => import("../views/CMSEmailFormLog/CMSEmailFormLogList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_email_form_logs/add",
    name: "CMSEmailFormLogAdd",
    component: () => import("../views/CMSEmailFormLog/CMSEmailFormLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_email_form_logs/:id/edit",
    name: "CMSEmailFormLogEdit",
    component: () => import("../views/CMSEmailFormLog/CMSEmailFormLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_email_form_logs/:id/show",
    name: "CMSEmailFormLogShow",
    component: () => import("../views/CMSEmailFormLog/CMSEmailFormLogShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_contact_forms",
    name: "CMSContactFormList",
    component: () => import("../views/CMSContactForm/CMSContactFormList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_contact_forms/add",
    name: "CMSContactFormAdd",
    component: () => import("../views/CMSContactForm/CMSContactFormForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_contact_forms/:id/edit",
    name: "CMSContactFormEdit",
    component: () => import("../views/CMSContactForm/CMSContactFormForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_contact_forms/:id/show",
    name: "CMSContactFormShow",
    component: () => import("../views/CMSContactForm/CMSContactFormShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_contact_form_logs",
    name: "CMSContactFormLogList",
    component: () => import("../views/CMSContactFormLog/CMSContactFormLogList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_contact_form_logs/add",
    name: "CMSContactFormLogAdd",
    component: () => import("../views/CMSContactFormLog/CMSContactFormLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_contact_form_logs/:id/edit",
    name: "CMSContactFormLogEdit",
    component: () => import("../views/CMSContactFormLog/CMSContactFormLogForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_contact_form_logs/:id/show",
    name: "CMSContactFormLogShow",
    component: () => import("../views/CMSContactFormLog/CMSContactFormLogShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_custom_field_details",
    name: "CMSCustomFieldDetailList",
    component: () => import("../views/CMSCustomFieldDetail/CMSCustomFieldDetailList.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_custom_field_details/add",
    name: "CMSCustomFieldDetailAdd",
    component: () => import("../views/CMSCustomFieldDetail/CMSCustomFieldDetailForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_custom_field_details/:id/edit",
    name: "CMSCustomFieldDetailEdit",
    component: () => import("../views/CMSCustomFieldDetail/CMSCustomFieldDetailForm.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
  {
    path: "/admin/cms_custom_field_details/:id/show",
    name: "CMSCustomFieldDetailShow",
    component: () => import("../views/CMSCustomFieldDetail/CMSCustomFieldDetailShow.vue"),
    meta: {
      requireAuth: true, layout: MasterLayout,
    },
  },
];

export default routes;
